import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { mutation as updateTagMutation, buildVariables as buildUpdateVariables } from './update-tag-mutation-builder';

import { TAGS_WITH_PIPELINE_COUNT_QUERY } from '../tags-with-pipeline-count-query-builder';
import { TAGS_QUERY } from '../useQueryTags';

export default function useUpdateTag(options = {}) {
  const [executeMutation, response] = useMutation(updateTagMutation, {
    context: { permission: permissions.writeTags },
    successMsg: 'Tag updated.',
    refetchQueries: [TAGS_WITH_PIPELINE_COUNT_QUERY, TAGS_QUERY],
    ...options,
  });

  const updateTag = ({ id, label }) => {
    return executeMutation(buildVariables({ id, label }));
  };

  return [updateTag, response];
}

function buildVariables({ id, label }) {
  return {
    variables: buildUpdateVariables({ id, label }),
  };
}
